import { MovieClip } from '@play-co/timestep-core/ui';
import { Container, Texture } from '../../../odie';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { PiggyBankBlockProps } from './PiggyBankBlock';
import { CountBlockOptionDef } from '../../defs/block';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/piggyBank/movieclip'),
    loadMethod: MovieClip.animationLoader,
  },
  all: getMatch2AssetPath('blocks/piggyBank'),
});

export class PiggyBankBlockView extends Container {
  private movieclip: MovieClip;
  private _count = 0;

  constructor(props: PiggyBankBlockProps) {
    super();
    blockPositionView(this, props);

    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.97,
      defaultAnimation: 'piggybank_stage1',
    });
  }

  public static assets() {
    return Object.values(manifest());
  }

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    this._count = value;
    this.updateView();
  }

  private updateView() {
    switch (this._count) {
      case 2:
        this.movieclip.play('piggybank_stage1');
        break;
      case 1:
        this.movieclip.play('piggybank_stage2');
        break;
    }
  }
}

export function _createPiggyBankBlockView(
  props: PiggyBankBlockProps,
  option: number,
): PiggyBankBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new PiggyBankBlockView(props);
  view.count = optionDef.count;
  return view;
}
